// SUMMARY: Navbar app launcher - a Grip button opening the app grid in a dropdown.

'use client'

import { Grip } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { Button } from '@/components/ui/button'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuLabel,
	DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { AppGrid } from '@/components/nav/app-grid'

export function AppGridMenu() {
	const t = useTranslations('nav.apps')

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant="ghost" size="icon" aria-label={t('trigger')}>
					<Grip className="h-5 w-5" />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" className="w-72">
				<DropdownMenuLabel className="px-3 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
					{t('title')}
				</DropdownMenuLabel>
				<AppGrid variant="menu" />
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
